import { render, staticRenderFns } from "./EditCategoty.vue?vue&type=template&id=3048c988&"
import script from "./EditCategoty.vue?vue&type=script&lang=js&"
export * from "./EditCategoty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports